import React, { useRef, useState } from 'react';
import styles from './HandbookFullImage.module.scss';
import Description from '../../Components/Description/Description';
import Button from '../../Components/Button/Button';
import Title from '../../Components/Title/Title';
import Image from '../../Components/Image/Image';
import { TitleOverlayWrapper } from '../../../../functions';

const HandbookFullImage = ({ api }) => {
  const titleWrapperRef = useRef();
  // const [currentOverlayStyle, setCurrentOverlayStyle] = useState({});

  // const handleResize = (event) => {
  //   const newStyles = {
  //     top: titleWrapperRef?.current?.offsetTop,
  //     left: titleWrapperRef?.current?.offsetLeft,
  //     width: titleWrapperRef?.current?.offsetWidth,
  //     height: titleWrapperRef?.current?.offsetHeight,
  //   };
  //   setCurrentOverlayStyle(newStyles);
  // };
  //
  // React.useEffect(() => {
  //   setTimeout(() => {
  //     handleResize();
  //   }, '1000');
  //
  //   window.addEventListener('resize', e => handleResize(e));
  //
  //   return (_) => {
  //     window.removeEventListener('resize', e => handleResize(e));
  //   };
  // }, []);

  return (
    <section id={api?.id} className={`wrapper ${styles.sectionServices}`}>
      <Image
        animationData={{
          animation: 'fade-up',
          animationDuration: '500',
          animationEasing: 'easy-in-out',
        }}
        properties={api.attributes}
        type="mod39"
      />
      <div className={styles.bg} data-aos="fade-up" data-aos-duration="500" data-aos-easing="ease-in-out" data-aos-once="false"></div>
      {(!!api.attributes.title || !!api.attributes.description || (!!api.attributes.btnText && !!api.attributes.btnLink)) && (
        <TitleOverlayWrapper styles={styles} titleWrapperRef={titleWrapperRef}>
          <div
            className={styles.containerContext}
            data-aos="fade-up"
            data-aos-duration="500"
            data-aos-easing="ease-in-out"
            data-aos-once="false"
            ref={titleWrapperRef}
          >
            <Title title={api.attributes.title} type="title-59" />
            <Description api={api} type="fullImage" />
            <Button api={api} type="lightButton right-images" />
          </div>
        </TitleOverlayWrapper>
      )}
    </section>
  );
};

export default HandbookFullImage;
